import { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import useAxios from 'axios-hooks'
import { getPcekZone } from '@entities/user'
import { FetchQRStatus, PayStatusSBP } from '@entities/payment'
import { reqHeaders } from '@shared/config/constants'
import { baseUmpPath } from '@root/api/api'

interface UseFetchQRStatusProps {
  id: string
  qrLink: string
}

export const useFetchQRStatus = ({ id, qrLink }: UseFetchQRStatusProps) => {
  const [redirectToResultDesktopSBP, setRedirectToResultDesktopSBP] = useState<boolean>(false)
  const [stateQr, setStateQr] = useState<string | null>(null)
  const zone = getPcekZone()
  const router = useRouter()

  const [, fetchQRStatus] = useAxios<FetchQRStatus>(
    {
      url: `${baseUmpPath}/${zone}/qr-transfer/state/qr?requestId=${id}`,
      method: 'GET',
      headers: {
        'X-Request-ID': id,
        ...reqHeaders,
      },
    },
    { manual: true }
  )

  useEffect(() => {
    let intervalId: NodeJS.Timeout

    const fetchStatus = async () => {
      try {
        const { data } = await fetchQRStatus()

        setStateQr(data.stateQr)

        if (data.stateQr === PayStatusSBP.ACCEPTED) {
          setRedirectToResultDesktopSBP(true)
          if (intervalId) {
            clearInterval(intervalId)
          }
        }
      } catch (error) {
        console.error('Error fetching QR status:', error)
      }
    }

    if (qrLink) {
      const initialTimeout = setTimeout(() => {
        void fetchStatus()
      }, 15000)

      if (stateQr === 'NTST' || !stateQr) {
        intervalId = setInterval(fetchStatus, 15000)
      }

      return () => {
        if (intervalId) {
          clearInterval(intervalId)
        }
        clearTimeout(initialTimeout)
      }
    }
  }, [id, qrLink, fetchQRStatus, stateQr, router])

  return { redirectToResultDesktopSBP }
}
